import React from 'react';
import { Link } from 'react-router-dom';

function EntityLink({ children, className = '', ...props }) {
  const classes = ['d-inline-flex align-items-center gap-1', className].filter(Boolean).join(' ');

  return (
    <Link {...props} className={classes}>
      {children}
      <i className="ti ti-external-link text-body-secondary small" aria-hidden="true"></i>
    </Link>
  );
}

export default EntityLink;
